import Controller from './analytics-controller'

export default class extends Controller {
  static values = {
    category: String,
    action: String,
    label: String,
    isMainPage: Boolean
  }

  handleClickLink (event) {
    if (!this.isMainPageValue) return

    const linkElement = event.target.closest('a')

    if (!linkElement) return

    this.labelValue = linkElement.href

    this.sendEvent()
  }
}
